import { Block, Typography } from '@aloft/toolkit-sui';

export const PairedTwoLineCell = ({
  primary,
  secondary,
}: {
  primary: string;
  secondary: string;
}) => (
  <Block>
    <Typography variant="body1">{primary}</Typography>
    <Typography variant="body2" color="textSecondary">
      {secondary}
    </Typography>
  </Block>
);
